/**
 * Keadaan keluar yang berarti pasien meninggal (blanko RM.RI.19.01.02 hal. 1).
 * Cermin dari App\Rmk::KONDISI_MENINGGAL — pemicu wajib-isi halaman 2 "Sebab Kematian".
 */
export const KONDISI_MENINGGAL = [
  "meninggal-kurang-48jam",
  "meninggal-lebih-48jam",
  "iufd",
];

export function isMeninggal(kondisiKeluar?: string | null): boolean {
  return !!kondisiKeluar && KONDISI_MENINGGAL.indexOf(kondisiKeluar) !== -1;
}

export function emptySebabKematian(): any {
  return {
    part1_a_penyakit: null,
    part1_a_icd10: null,
    part1_a_interval: null,
    part1_b_penyakit: null,
    part1_b_icd10: null,
    part1_b_interval: null,
    part1_c_penyakit: null,
    part1_c_icd10: null,
    part1_c_interval: null,
    part2_penyakit: null,
    part2_icd10: null,
    part2_interval: null,
    ruda_paksa_ada: null,
    ruda_paksa_macam: null,
    ruda_paksa_cara_kejadian: null,
    ruda_paksa_sifat_jejas: null,
    kelahiran_mati: null,
    kelahiran_mati_sebab: null,
    peristiwa_persalinan: null,
    peristiwa_kehamilan: null,
    operasi_dilakukan: null,
    operasi_jenis: null,
    tempat_keterangan: "Bantul",
    tgl_keterangan: null,
  };
}
